import React from 'react';
import {
  STAGE0,
  stage0UnitMeta,
} from 'constants/FarmboxConstants/stage0.constants';
import { FieldType } from 'enums/FieldTypeEnums';
import { ReactComponent as DeleteButton } from 'assets/icons/close_enclosed.svg';
import styles from './farmCommodity.module.scss';
import { CoProductsComponentProps } from './CoProductsComponent';
import { Stage0MetaData } from 'models/Farmbox/commodity.model';
import clsx from 'clsx';
import { DefaultOptionType } from 'antd/lib/select';

interface Stage0Props {
  metaData: Stage0MetaData[];
  isDisabled?: boolean;
}

export const getStage0Data = (props: Stage0Props) => {
  const { metaData, isDisabled } = props;
  const { LABELS, FIELD_NAMES } = STAGE0;
  const {
    FARM,
    DRY_WEIGHT,
    WET_WEIGHT,
    COMMODITY_DESCRIPTION,
    HARVEST_YEAR,
    PRODUCT_NAME,
    CROP_TYPE,
    UNIT,
    FARM_REVENUE,
    FIELD_AREA,
  } = LABELS;
  const {
    FARM_NAME,
    DRY_WEIGHT_NAME,
    WET_WEIGHT_NAME,
    COMMODITY_DESCRIPTION_NAME,
    HARVEST_YEAR_NAME,
    PRODUCT_NAME_NAME,
    CROP_TYPE_NAME,
    UNIT_NAME,
    FARM_REVENUE_NAME,
    FIELD_AREA_NAME,
  } = FIELD_NAMES;
  return {
    data: [
      {
        type: FieldType.INPUT,
        fieldProps: {
          name: FARM_NAME,
          label: FARM,
          placeholderstring: FARM,
          disabled: true,
        },
        span: 12,
      },
      {
        type: FieldType.INPUT,
        fieldProps: {
          name: HARVEST_YEAR_NAME,
          label: HARVEST_YEAR,
          placeholderstring: HARVEST_YEAR,
          disabled: true,
        },
        span: 12,
      },
      {
        type: FieldType.INPUT,
        fieldProps: {
          name: PRODUCT_NAME_NAME,
          label: PRODUCT_NAME,
          placeholderstring: PRODUCT_NAME,
          disabled: isDisabled,
        },
        span: 12,
      },
      {
        type: FieldType.SELECT,
        fieldProps: {
          name: CROP_TYPE_NAME,
          label: CROP_TYPE,
          placeholderstring: CROP_TYPE,
          options: metaData,
          disabled: isDisabled,
          showSearch: true,
          filterOption: (inputValue?: string, option?: DefaultOptionType) => {
            const categoryOption = option as Stage0MetaData;
            return (
              categoryOption?.label
                ?.toString()
                ?.toLowerCase()
                .includes(inputValue?.toLowerCase() || '') || false
            );
          },
        },
        span: 12,
      },
      {
        type: FieldType.INPUT,
        fieldProps: {
          name: FIELD_AREA_NAME,
          label: FIELD_AREA,
          placeholderstring: FIELD_AREA,
          disabled: isDisabled,
        },
        span: 7,
      },
      {
        type: FieldType.SELECT,
        fieldProps: {
          name: UNIT_NAME,
          label: UNIT,
          placeholderstring: UNIT,
          options: stage0UnitMeta,
          disabled: isDisabled,
        },
        span: 5,
      },
      {
        type: FieldType.INPUT,
        fieldProps: {
          name: FARM_REVENUE_NAME,
          label: FARM_REVENUE,
          placeholderstring: FARM_REVENUE,
          disabled: isDisabled,
        },
        span: 12,
      },
      {
        type: FieldType.INPUT,
        fieldProps: {
          name: DRY_WEIGHT_NAME,
          label: DRY_WEIGHT,
          placeholderstring: DRY_WEIGHT,
          disabled: isDisabled,
        },
        span: 12,
      },
      {
        type: FieldType.INPUT,
        fieldProps: {
          name: WET_WEIGHT_NAME,
          label: WET_WEIGHT,
          placeholderstring: WET_WEIGHT,
          disabled: isDisabled,
        },
        span: 12,
      },
      {
        type: FieldType.INPUT,
        fieldProps: {
          textarea: true,
          name: COMMODITY_DESCRIPTION_NAME,
          label: COMMODITY_DESCRIPTION,
          placeholderstring: COMMODITY_DESCRIPTION,
          disabled: isDisabled,
        },
        span: 24,
      },
    ],
  };
};

export const getCoProductsData = (params: CoProductsComponentProps) => {
  const { remove, index, isDisabled } = params;
  const removeHandler = () => remove?.(index);
  const { LABELS, FIELD_NAMES } = STAGE0;
  const { CO_PRODUCT_NAME, ALLOCATION } = LABELS;
  const { PRODUCT_NAME_NAME, CO_PRODUCTS, ALLOCATION_NAME } = FIELD_NAMES;
  return {
    data: [
      {
        type: FieldType.INPUT,
        fieldProps: {
          name: `${CO_PRODUCTS}.${index}.${PRODUCT_NAME_NAME}`,
          label: CO_PRODUCT_NAME,
          placeholderstring: CO_PRODUCT_NAME,
          disabled: isDisabled,
        },
        span: 11,
      },
      {
        type: FieldType.INPUT,
        fieldProps: {
          name: `${CO_PRODUCTS}.${index}.${ALLOCATION_NAME}`,
          label: ALLOCATION,
          placeholderstring: ALLOCATION,
          disabled: isDisabled,
        },
        span: 11,
      },
      {
        type: FieldType.ELEMENT,
        additionalElement: (
          <div
            className={clsx(styles.deleteContainer, {
              [styles.hideAction]: isDisabled,
            })}
            onClick={removeHandler}>
            <DeleteButton />
          </div>
        ),
        span: 2,
      },
    ],
  };
};
